/**
 * Theme-aware colors for inline styles, gradients, and SVG fills.
 * Prefer WDS Box token props (D60, B10, etc.) when the component supports them.
 *
 * Values are CSS variables without fallbacks — React inline styles reject
 * `var(--token, #fallback)` because the comma is parsed as a style separator.
 * Theme tokens must be provided by the host (REP dark/light skin) or Storybook decorators.
 */
export const wdsThemeColors = {
  borderDarkSecondary: 'var(--wds-color-border-dark-secondary)',
  borderFocus: 'var(--wds-color-border-standard-primary-active)',
  borderFocusStrong: 'var(--wds-color-border-standard-primary)',
  /** Studio 2 / odeditor-dark card outlines (D60 equivalent). */
  borderStandard: 'var(--wds-color-border-standard-secondary)',
  borderStandardDark: 'var(--wds-color-border-dark-secondary)',
  /** Studio element panel hover/open outline (WIXSEO-3977). */
  borderStandardSecondaryHover: 'var(--wds-color-border-standard-secondary-hover)',
  iconDisabled: 'var(--wds-color-fill-standard-primary-disabled)',
  iconPrimary: 'var(--wds-color-fill-standard-primary)',
  iconSecondary: 'var(--wds-color-fill-standard-secondary)',
  imagePlaceholder: 'var(--wds-color-fill-surface-neutral)',
  panelBackground: 'var(--wds-color-white)',
  statusDestructive: 'var(--wds-color-fill-destructive-primary)',
  statusSuccess: 'var(--wds-color-fill-success-primary)',
  statusWarning: 'var(--wds-color-fill-warning-primary)',
  surfaceNeutral: 'var(--wds-color-fill-surface-neutral)',
  surfaceTertiary: 'var(--wds-color-fill-standard-tertiary)',
  textPrimary: 'var(--wds-color-text-standard-primary)',
  textSecondary: 'var(--wds-color-text-standard-secondary)'
};
export const wdsStickyHeaderSideShadow = `-6px 0 0 0 ${wdsThemeColors.surfaceTertiary}, 6px 0 0 0 ${wdsThemeColors.surfaceTertiary}`;
/**
 * Maps a WDS CSS variable or legacy Box color token to Box props.
 * CSS variables must use `style` because Box token props only accept palette keys.
 */
export const resolveWdsBoxColorProps = function (color, property) {
  if (property === void 0) {
    property = 'backgroundColor';
  }
  if (!color) {
    return {};
  }
  if (color.startsWith('var(')) {
    return {
      style: {
        [property]: color
      }
    };
  }
  return {
    [property]: color
  };
};
export const mergeWdsBoxColorProps = function () {
  for (var _len = arguments.length, propsList = new Array(_len), _key = 0; _key < _len; _key++) {
    propsList[_key] = arguments[_key];
  }
  const merged = propsList.reduce((acc, props) => ({
    ...acc,
    ...props,
    style: {
      ...acc.style,
      ...props.style
    }
  }), {});
  if (merged.style && Object.keys(merged.style).length === 0) {
    delete merged.style;
  }
  return merged;
};
export const getWdsSurfaceNeutralProps = () => resolveWdsBoxColorProps(wdsThemeColors.surfaceNeutral);
export const getWdsSurfaceTertiaryProps = () => resolveWdsBoxColorProps(wdsThemeColors.surfaceTertiary);
//# sourceMappingURL=wds-theme-colors.js.map